import { render, staticRenderFns } from "./LoginOrRegister.vue?vue&type=template&id=47043dda&"
import script from "./LoginOrRegister.vue?vue&type=script&lang=js&"
export * from "./LoginOrRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports